import React from "react";

const Youtube = ({ ...rest }) => {
    return (
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="youtube">
                <g id="Icon">
                    <path
                        d="M21.5813 7.30242C21.4733 6.871 21.2534 6.47571 20.9438 6.15649C20.6341 5.83727 20.2457 5.60541 19.8178 5.48434C18.2542 5.10254 12 5.10254 12 5.10254C12 5.10254 5.74578 5.10254 4.18222 5.5207C3.75429 5.64177 3.36588 5.87363 3.05623 6.19285C2.74659 6.51208 2.52666 6.90736 2.41868 7.33879C2.13253 8.92557 1.99255 10.5353 2.00052 12.1476C1.99032 13.7721 2.1303 15.3941 2.41868 16.9928C2.53773 17.4109 2.76258 17.7911 3.0715 18.0968C3.38043 18.4026 3.76299 18.6235 4.18222 18.7382C5.74578 19.1564 12 19.1564 12 19.1564C12 19.1564 18.2542 19.1564 19.8178 18.7382C20.2457 18.6171 20.6341 18.3853 20.9438 18.066C21.2534 17.7468 21.4733 17.3515 21.5813 16.9201C21.8653 15.3453 22.0052 13.7478 21.9995 12.1476C22.0097 10.5231 21.8697 8.90116 21.5813 7.30242Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9.75 9.56787C9.75 9.09059 9.75 8.85194 9.84974 8.71872C9.93666 8.60261 10.0697 8.52997 10.2144 8.51964C10.3804 8.50779 10.5811 8.63683 10.9826 8.89493L14.9254 11.4296C15.2738 11.6536 15.448 11.7655 15.5082 11.9079C15.5607 12.0323 15.5607 12.1727 15.5082 12.2971C15.448 12.4395 15.2738 12.5515 14.9254 12.7755L10.9826 15.3102C10.5811 15.5682 10.3804 15.6973 10.2144 15.6854C10.0697 15.6751 9.93666 15.6025 9.84974 15.4864C9.75 15.3531 9.75 15.1145 9.75 14.6372V9.56787Z"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </g>
            </g>
        </svg>
    );
};

export default Youtube;
